import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CheckChangeOrderService } from '@woolworthsnz/order';
import { ShopperChangeOrderCheck } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class ChangeOrderInterceptor implements HttpInterceptor {
	constructor(private checkChangeOrderService: CheckChangeOrderService) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap((event: HttpEvent<any>) => {
				if (event instanceof HttpResponse && event?.body?.changeOrderCheck) {
					const changeOrderCheck = event.body.changeOrderCheck as ShopperChangeOrderCheck;

					this.checkChangeOrderService.handleShopperChangeOrderCheck(changeOrderCheck);
				}
			})
		);
	}
}
